import React, { createContext, ReactNode, useContext } from 'react';

import type { FinancialPortal } from '@generated-gql/generated-types';

interface PlaidFooterInstitutionsContextProps {
  linkingState: {
    isLinking: boolean;
    numAccountsLinking: number;
  };
  actionRequiredState: {
    portal: FinancialPortal | null;
    isActionRequired: boolean;
    numAccountsActionRequired: number;
  };
}

const PlaidFooterInstitutionsContext =
  createContext<PlaidFooterInstitutionsContextProps>({
    linkingState: {
      isLinking: false,
      numAccountsLinking: 0,
    },
    actionRequiredState: {
      portal: null,
      isActionRequired: false,
      numAccountsActionRequired: 0,
    },
  });

interface PlaidFooterInstitutionProviderProps {
  children: ReactNode;
  linkingState?: {
    isLinking: boolean;
    numAccountsLinking: number;
  };
  actionRequiredState?: {
    portal: FinancialPortal | null;
    isActionRequired: boolean;
    numAccountsActionRequired: number;
  };
}

const PlaidFooterInstitutionProvider: React.FC<
  PlaidFooterInstitutionProviderProps
> = ({ children, linkingState, actionRequiredState }) => {
  return (
    <PlaidFooterInstitutionsContext.Provider
      value={{
        linkingState,
        actionRequiredState,
      }}
    >
      {children}
    </PlaidFooterInstitutionsContext.Provider>
  );
};

const usePlaidFooterInstitutionContext = () =>
  useContext(PlaidFooterInstitutionsContext);

export { PlaidFooterInstitutionProvider, usePlaidFooterInstitutionContext };
